const littleRed = "#d52029";
const littleBlue = "#1268ad";
const littleYellow = "#EBB220";
const littleGreen = "#0d9848";
export { littleRed, littleBlue, littleYellow, littleGreen };
 